import { render } from "./siteMusic.vue?vue&type=template&id=dc4cce46"
import script from "./siteMusic.vue?vue&type=script&lang=js"
export * from "./siteMusic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__